import { UIFooter, UIButtonGhost } from '@workspace/ui/composed';
import { useTranslations } from '../../i18n/useTranslations';

function Footer() {
  const { t } = useTranslations('footer');

  const getTermsBaseUrl = () => {
    const currentDomain = window.location.hostname;
    const domainParts = currentDomain.split('.');
    domainParts[0] = 'terms';
    return `https://${domainParts.join('.')}`;
  };

  const openInPopup = (path: string, title: string) => {
    const width = 800;
    const height = 700;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;
    const url = `${getTermsBaseUrl()}${path}`;
    window.open(
      url,
      title,
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes`
    );
  };

  const links = [
    { label: t('termsOfService'), onClick: () => openInPopup('/terms', t('termsOfService')) },
    { label: t('privacyPolicy'), onClick: () => openInPopup('/privacy', t('privacyPolicy')) },
  ];

  return (
    <UIFooter
      copyright={t('copyright')}
      showBusinessInfo={false}
      links={links}
      renderLink={(link, index) => (
        <UIButtonGhost
          key={index}
          size="sm"
          onClick={link.onClick}
          className="text-xs h-auto py-1 px-2"
        >
          {link.label}
        </UIButtonGhost>
      )}
    />
  );
}

export default Footer;
